import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS, STALE_TIME } from '@/libs/constants'
import type {
  BookingListParams,
  HookParams,
  KPIData,
  Order,
  ProductInventoryItem,
  ProductInventoryItemParams,
} from '@/libs/interfaces'
import { bookingsApi, dashboardApi } from '@/services/api'

export function useDashboardKPIs(orgId: string, storeID?: string, from?: string) {
  return useQuery<KPIData>({
    queryKey: ['dashboard', 'kpis', orgId, storeID, from],
    enabled: !!orgId,
    queryFn: async () => {
      const [totalBilled, totalBookings, totalEmployees, totalServices] = await Promise.all([
        dashboardApi.getKPITotalBilled(orgId, storeID, from),
        dashboardApi.getKPITotalBookings(orgId, storeID, from),
        dashboardApi.getKPITotalEmployees(orgId, storeID, from),
        dashboardApi.getKPITotalServices(orgId, storeID, from),
      ])

      return {
        totalRevenue: { value: String(totalBilled?.data?.data?.totalBilled) },
        totalBookings: { value: String(totalBookings?.data?.data?.totalBookings) },
        totalEmployees: { value: String(totalEmployees?.data?.data?.totalEmployees) },
        totalServices: { value: String(totalServices?.data?.data?.totalServices) },
      }
    },
    refetchOnWindowFocus: false,
    staleTime: STALE_TIME['24Hours'], // 24 hours
  })
}

export function useDashboardLowInventory({
  params,
  enabled,
}: HookParams<ProductInventoryItemParams>) {
  return useQuery<ProductInventoryItem[]>({
    queryKey: QUERY_KEYS.dashboard.lowInventory(params),
    queryFn: async () => {
      return await dashboardApi.getinventoryStatus(params)
    },
    enabled: enabled ?? true,
    staleTime: STALE_TIME['24Hours'], // 24 hours
  })
}

export function useDashboardTodayServices({ params, enabled }: HookParams<BookingListParams>) {
  return useQuery<Order[]>({
    queryKey: QUERY_KEYS.bookings.list(params),
    enabled: enabled ?? true,
    queryFn: async () => {
      return await bookingsApi.list(params)
    },

    staleTime: STALE_TIME['1Hour'], // 1 hour
  })
}
